export default __webpack_public_path__ + "assets/media/13-12-1022-4-1004106-main.jpg";